import { Button, ButtonGroup, IconButton, Pagination, Stack, SxProps, Tooltip } from "@mui/material";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";


interface TimeframePaginationProps {
  onPrevious: () => void;
  onNext: () => void;
  disablePrevious?: boolean;
  disableNext?: boolean;
  sx?: SxProps;
  type?: "month" | "year";
}

const TimeframePagination: React.FC<TimeframePaginationProps> = ({ onPrevious, onNext, disablePrevious, disableNext, sx, type="month" }) => {
    const previousLabel = type === "year" ? "Vorheriges Jahr": "Vorheriger Monat";
    const nextLabel = type === "year" ? "Nächstes Jahr": "Nächster Monat";

    return (
      <ButtonGroup variant="contained">
        <Tooltip title={previousLabel} placement="top">
          <Button sx={{ minHeight: 30, width: 30, ...sx}} size="small" onClick={onPrevious} disabled={disablePrevious}>
            <NavigateBefore fontSize="small" />
          </Button>
        </Tooltip>
        <Tooltip title={nextLabel} placement="top">
          <Button sx={{ minHeight: 30, width: 30, ...sx}} size="small" onClick={onNext} disabled={disableNext}>
            <NavigateNext fontSize="small" />
          </Button>
        </Tooltip>
      </ButtonGroup>
    );
}

export default TimeframePagination;